// extracted by mini-css-extract-plugin
module.exports = {"transactionHistory":"TransactionHistory_transactionHistory__3AFC6"};